export const SET_LOADING = '[PAYMENT METHODS] SET_LOADING';
export const SET_ERROR = '[PAYMENT METHODS] SET_ERROR';
export const SET_BANKSLIP_LOADING = '[PAYMENT METHODS] SET_BANKSLIP_LOADING';
export const SET_PURCHASE_ORDER = '[PAYMENT METHODS] SET_PURCHASE_ORDER';
